import Profile from "../components/svg/navigation/Profile";
import Guild from "../components/svg/navigation/Guild";
import Transportation from "../components/svg/navigation/Transportation";
import Margrave from "../components/svg/navigation/Margrave";
import {useLocation, Link} from "react-router-dom";
import Vaccine from "../components/svg/navigation/Vaccine";

const Navigation = () => {
  const location = useLocation();

  const {pathname} = location;

  return (
    <div className="navigation">
      <ul>
        <li className={pathname === "/profile" ? "active" : ""}>
          <Link to="/profile">
            <Profile/>
          </Link>
        </li>

        <li className={/^\/margrave?./.test(pathname) ? "active" : ""}>
          <Link to="/margrave">
            <Margrave/>
          </Link>
        </li>
        <li className={/^\/vaccination?./.test(pathname) ? "active" : ""}>
          <Link to="/vaccination">
            <Vaccine/>
          </Link>
        </li>
        <li className={pathname === "/guild" ? "active" : ""}>
          <Link to="/guild">
            <Guild/>
          </Link>
        </li>
        <li className={pathname === "/transportation" ? "active" : ""}>
          <Link to="/transportation">
            <Transportation/>
          </Link>
        </li>

      </ul>
    </div>
  );
};

export default Navigation;
